import { z } from "zod"

export const DELIVERY_PII_RETENTION_DEFAULT_DAYS = 90
export const DELIVERY_PII_RETENTION_MIN_DAYS = 1
export const DELIVERY_PII_RETENTION_MAX_DAYS = 90
export const DELIVERY_PII_RETENTION_ERROR_CODE =
  "recipient_pii_retention_expired"

export const deliveryPiiRetentionPolicySchema = z.object({
  recipientPiiRetentionDays: z.number().int()
    .min(DELIVERY_PII_RETENTION_MIN_DAYS)
    .max(DELIVERY_PII_RETENTION_MAX_DAYS),
}).strict()

export type DeliveryPiiRetentionPolicy = z.infer<
  typeof deliveryPiiRetentionPolicySchema
>
